import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireFunctions } from '@angular/fire/functions';
import * as firebase from 'firebase'; //Timestamp (firebase.default.database.ServerValue.TIMESTAMP)
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';


import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { Boleto } from '../interfaces/sicoob/boleto';
import { CreditoVoucherHistorico } from '../interfaces/creditoVoucherHistorico';
import { Loja } from '../interfaces/manutencao.sistema';
import { LogEstoqueProdutos, ProdutoEstoqueConsulta, ProdutoEstoqueElement } from '../interfaces/produtos.estoque';
// import * as fs from 'fs';

// import * as path from 'path';
// const pfx = fs.readFileSync('C:/Users/wihar/Documents/CertificadoDistribuidoraIpanema/CertificadoIpanema.pfx');

@Injectable()
export class UsuarioService {
  uidConfig = environment.idCliente;
  baseURL = environment.apiBoletoUrl;
  certificado: Observable<string | null>;

  constructor(
    private db: AngularFireDatabase,
    private fns: AngularFireFunctions,
    private router: Router,
    private toastr: ToastrService,
    // private http: Http,
    private httpClient: HttpClient
  ) { }

  //Saber se o sistema esta em manutencao ou nao
  getStatusServidor() {
    return this.db.object('Clientes/' + this.uidConfig + '/Sistema/Admin').snapshotChanges();
  }

  //Cadastro um novo fornecedor
  setFornecedor(map, uid) {
    const key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/Fornecedores/' + key).set(map).then(resp => {
      this.showToast('success', 'Fornecedor cadastrado com sucesso!', 'Status');
      return key;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Recupera os fornecedores
  getFornecedores(uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Fornecedores').snapshotChanges();
  }


  //Recupera o Fornecedor pelo CNPJ
  getFornecedorCNPJ(cnpj, uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Fornecedores', ref => ref.orderByChild('CNPJ').equalTo(cnpj)).snapshotChanges();
  }

  //Atualiza o fornecedore
  updateFornecedor(uid, idFornecedor, map) {
    return this.db.object('Clientes/' + environment.idCliente + '/Fornecedores/' + idFornecedor).update(map);
  }

  //Cadastra um novo grupo
  setGrupo(uid, nomeGrupo) {
    const key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/Grupos/' + key + '/Nome').set(nomeGrupo).then(resp => {
      this.showToast('success', 'Grupo cadastrado com sucesso!', 'Status');
      return key;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Recupera os fornecedores para validar duplicatas
  getGrupoDuplicado(uid, nomeGrupo) {
    return this.db.list('Clientes/' + environment.idCliente + '/Grupos/', ref => ref.orderByChild('Nome').equalTo(nomeGrupo)).snapshotChanges();
  }

  //Recupera os grupos
  getGrupos(uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Grupos').snapshotChanges();
  }

  //Atualiza o Grupo
  updateGrupo(uid, nomeGrupo, idGrupo) {
    return this.db.object('Clientes/' + environment.idCliente + '/Grupos/' + idGrupo).update({ Nome: nomeGrupo });
  }

  //Recupera o código atual para um novo produto
  getContCodigoProdutos(uid) {
    return this.db.object('Clientes/' + environment.idCliente + '/ContCodigoProdutos').valueChanges();
  }

  //Cadastro um novo produto
  setProduto(map, uid) {
    const key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/Produtos/' + key).set(map).then(resp => {
      this.showToast('success', 'Produto cadastrado com sucesso!', 'Status');
      return key;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Recupera todos os produtos
  updateProduto(map, key) {
    return this.db.object('Clientes/' + environment.idCliente + '/Produtos/' + key).update(map);
  }

  //Recupera todos os produtos
  getProdutos() {
    return this.db.list('Clientes/' + environment.idCliente + '/Produtos/').snapshotChanges();
  }

  //Recupera o produto pelo ID
  getProdutoID(idProduto, uid) {
    return this.db.object('Clientes/' + environment.idCliente + '/Produtos/' + idProduto).snapshotChanges();
  }

  //Recupera os fornecedores para validar duplicatas
  getProdutoCodBarras(uid, cod) {
    return this.db.list('Clientes/' + environment.idCliente + '/Produtos/', ref => ref.orderByChild('CodigoBarras').equalTo(cod)).snapshotChanges();
  }

  //Recupera o produto pelo inicio do nome
  getBuscaInicioNomeProduto(uid, nome) {
    return this.db.list('Clientes/' + environment.idCliente + '/Produtos/', ref => ref.orderByChild('NomeBusca').startAt(nome.toUpperCase()).endAt(nome.toLowerCase() + '\uf8ff').limitToLast(50)).snapshotChanges();
  }

  //Recupera o produto pelo código de barras
  getBuscaCodigoBarras(uid, codigo) {
    return this.db.list('Clientes/' + environment.idCliente + '/Produtos/', ref => ref.orderByChild('CodigoBarras').startAt(codigo).endAt(codigo + '\uf8ff').limitToLast(50)).snapshotChanges();
  }

  setLog(descricao, mapDados, uid) {
    let auxDate = new Date();
    let map = {
      IP: localStorage.getItem('ip'),
      Timestamp: auxDate.getTime(),
      TimestampServidor: firebase.default.database.ServerValue.TIMESTAMP,
      Descricao: descricao,
      IDCliente: uid,
      IDCliente_Timestamp: uid + '_' + auxDate.getTime(),
      IP_Timestamp: localStorage.getItem('ip') + '_' + auxDate.getTime(),
      Map: mapDados ? JSON.stringify(mapDados) : false
    }

    let key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/Log/' + key).set(map);
  }

  //Busca por CEP
  async getBuscaCEP(cep) {
    let auxCep = cep;
    auxCep = auxCep.replace(".", "");
    auxCep = auxCep.replace("-", "");

    if (auxCep.length == 8) {
      return await this.httpClient.get('https://viacep.com.br/ws/' + auxCep + '/json/').toPromise();
    } else
      return false;
  }

  //Busca a latitude e longitude pelo endereço
  async getLatLng(endereco) {
    console.log(endereco)
    return await this.httpClient.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + endereco + '&key=AIzaSyBLhdcuvEPFwKz0gQHWvAFcl-rkL_JTSrE').toPromise();
  }

  updateLatitudeLongitude(idUsuario, latitude, longitude) {
    return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idUsuario).update({ Latitude: latitude, Longitude: longitude });
  }

  //Busca por logradouro
  async getBuscaLogradouro(cep) {

  }

  //Recupera as unidades de medidas duplicadas
  getUnidadeMedidaDuplicada(uid, nomeUnidade) {
    return this.db.list('Clientes/' + environment.idCliente + '/Unidades/', ref => ref.orderByChild('Nome').equalTo(nomeUnidade)).snapshotChanges();
  }

  //Cadastra uma nova unidade de medida
  setUnidadeMedida(uid, nomeUnidade) {
    const key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/Unidades/' + key + '/Nome').set(nomeUnidade).then(resp => {
      this.showToast('success', 'Unidade cadastrada com sucesso!', 'Status');
      return key;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Recupera as unidades de medida no sistema
  getUnidadesMedidas(uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Unidades').snapshotChanges();
  }

  //Atualiza o Grupo
  updateUnidadesMedidas(uid, nomeUnidade, idUnidade) {
    return this.db.object('Clientes/' + environment.idCliente + '/Unidades/' + idUnidade).update({ Nome: nomeUnidade });
  }

  //Recupera o cliente pelo CPF
  getClienteCPF(cpf, uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Usuarios', ref => ref.orderByChild('CPF').equalTo(cpf)).snapshotChanges();
  }

  //Recupera o cliente pelo CNPJ
  getClienteCNPJ(cnpj, uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Usuarios', ref => ref.orderByChild('CNPJ').equalTo(cnpj)).snapshotChanges();
  }

  //Recupera o cliente pelo IE
  getClienteIE(inscricaoEstadual, uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Usuarios', ref => ref.orderByChild('InscricaoEstadual').equalTo(inscricaoEstadual)).snapshotChanges();
  }

  //Cadastro um novo Cliente
  setCliente(map, uid, email, senha) {
    return this.fns.httpsCallable('registrarCliente')({ Map: map, IDMatriz: environment.idCliente, Email: email, Senha: senha }).toPromise()
      .then(resp => {
        return resp;
      })
      .catch(err => {
        console.log(err);
        return {
          Status: false,
          Mensagem: "Error  DESCONHECIDO ao criar o cliente: " + err.code
        }
      });
  }

  //atualiza um Cliente
  updateCliente(map, uid, idUsuario) {
    return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idUsuario).update(map).then(resp => {
      return this.db.object('Usuarios/' + idUsuario + '/Status/').set(map.Status).then(resp => {
        return {
          Status: true,
          Mensagem: "Usuário atualizado com sucesso!"
        };
      }).catch(err => {
        return {
          Status: false,
          Mensagem: "Error  DESCONHECIDO ao atualizar o Usuário: " + err.code
        };
      });;
    }).catch(err => {
      return {
        Status: false,
        Mensagem: "Error  DESCONHECIDO ao atualizar o Usuário: " + err.code
      };
    });
  }

  //Atualiza crédito do cliente
  updateCreditoCliente(idCliente, credito) {
    return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idCliente).update({ CreditoDisponivel: credito }).then(resp => {
      return true;
    }).catch(err => {
      return false;
    });
  }

  //Cadastro um novo funcionário
  setFuncionario(map, uid) {
    return this.fns.httpsCallable('registrarFuncionario')({ Map: map, IDMatriz: environment.idCliente }).toPromise()
      .then(resp => {
        return resp;
      })
      .catch(err => {
        console.log(err);
        return {
          Status: false,
          Mensagem: "Error  DESCONHECIDO ao criar o funcionário: " + err.code
        }
      });
  }

  //Recupera os funcionarios
  getFuncionarios(uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Funcionarios').snapshotChanges();
  }

  //Atualiza o funcionario
  updateFuncionario(map, uid, idFuncionario, status) {
    return this.db.object('Clientes/' + environment.idCliente + '/Funcionarios/' + idFuncionario).update(map).then(resp => {
      return this.db.object('Funcionarios/' + idFuncionario + '/Status/').set(status).then(resp => {
        return {
          Status: true,
          Mensagem: "Funcionário atualizado com sucesso!"
        };
      }).catch(err => {
        return {
          Status: false,
          Mensagem: "Error  DESCONHECIDO ao atualizar o funcionário: " + err.code
        };
      });;
    }).catch(err => {
      return {
        Status: false,
        Mensagem: "Error  DESCONHECIDO ao atualizar o gerefuncionárionte: " + err.code
      };
    });
  }

  //Recupera os clientes
  getClientes() {
    return this.db.list('Clientes/' + environment.idCliente + '/Usuarios').snapshotChanges();
  }

  //Recupera os clientes
  getClienteByID(idCliente) {
    return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idCliente).valueChanges();
  }

  //Recupera os clientes do vendedor
  getClientesVendedor(idVendedor) {
    return this.db.list('Clientes/' + environment.idCliente + '/Usuarios', ref => ref.orderByChild('IDVendedor').equalTo(idVendedor)).snapshotChanges();
  }

  //Recupera as solicitações de cadastro
  getSolicitacoesCadastrobVisualizada(uid) {
    //Se visualizar pelo Status igual, quando atualizado no BD, não recebe a atualização não é eliminado no header como visualizado
    return this.db.list('Clientes/' + environment.idCliente + '/SolicitacoesCadastro', ref => ref.orderByChild('bVisualizada').equalTo(false).limitToLast(1000)).snapshotChanges();
  }

  //Recupera as solicitações de cadastro
  getSolicitacoesCadastro(uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/SolicitacoesCadastro').snapshotChanges();
  }

  //Atualiza o fornecedores
  updateSolicitacaoCadastro(uid, idSolicitacao) {
    return this.db.object('Clientes/' + environment.idCliente + '/SolicitacoesCadastro/' + idSolicitacao + '/bVisualizada').set(true);
  }

  //Recupera os novos pedidos
  getNovosPedidos(uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Pedidos').snapshotChanges();
  }

  //Recupera os pedidos
  getPedidosTimestamp(timestampInicial, timestampFinal, tipoBusca) {
    if (tipoBusca === 'Período') {
      return this.db.list('Clientes/' + environment.idCliente + '/Pedidos', ref => ref.orderByChild('Timestamp').startAt(timestampInicial).endAt(timestampFinal)).snapshotChanges();
    } else {
      return this.db.list('Clientes/' + environment.idCliente + '/Pedidos', ref => ref.orderByChild('TimestampPrevisaoRota').startAt(timestampInicial).endAt(timestampFinal)).snapshotChanges();
    }
  }

  //Recupera Pedidos do cliente
  getPedidosCliente(idCliente: string) {
    return this.db.list('Clientes/' + environment.idCliente + '/Pedidos', ref => ref.orderByChild('IDUsuario').equalTo(idCliente)).snapshotChanges();

  }

  //Recupera os pedidosSomente do idVendedor
  getPedidosIDVendedorTimestamp(idVendedor, timestampInicial, timestampFinal) {
    return this.db.list('Clientes/' + environment.idCliente + '/Pedidos', ref => ref.orderByChild('IDVendedor_Timestamp').startAt(idVendedor + '_' + timestampInicial).endAt(idVendedor + '_' + timestampFinal)).snapshotChanges();
  }

  //Recupera o pedido pelo número
  getPedidoPorNumero(numeroPedido) {
    return this.db.object('Clientes/' + environment.idCliente + '/Pedidos/' + numeroPedido).snapshotChanges();
  }

  //Recupera os novos pedidos pelo status
  getNovosPedidosStatus(status) {
    //Se visualizar pelo Status igual, quando atualizado no BD, não recebe a atualização não é eliminado no header como visualizado
    return this.db.list('Clientes/' + environment.idCliente + '/Pedidos', ref => ref.orderByChild('Status').equalTo(status).limitToLast(1000)).snapshotChanges();
  }

  //Recupera o nome do vendedor
  getNomeVendedor(uid, idVendedor) {
    return this.db.object('Clientes/' + environment.idCliente + '/Funcionarios/' + idVendedor + '/Nome').snapshotChanges();
  }

  //Recupera o responsável atual pela compra do cliente
  getResponsavelCompra(uid, idCliente) {
    return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idCliente + '/ResponsavelCompra').snapshotChanges();
  }

  //Recupera os valores mínimos do sistema. Boleto e Pedido
  getValoresMinimos() {
    return this.db.object('Clientes/' + environment.idCliente + '/ValoresMinimos/').snapshotChanges();
  }

  //Atualiza os valores mínimos do sistema. Boleto e Pedido
  updateValoresMinimos(uid, map) {
    return this.db.object('Clientes/' + environment.idCliente + '/ValoresMinimos/').update(map);
  }

  //Recupera a cidade para saber se já está cadastrada
  getCidadeDuplicada(uid, uf, cidade) {
    return this.db.list('Clientes/' + environment.idCliente + '/Cidades/' + uf, ref => ref.orderByChild('Cidade').equalTo(cidade)).snapshotChanges();
  }

  //Cadastra uma nova cidade
  setCidade(uid, uf, cidade, latitude, longitude) {
    const key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/Cidades/' + uf + '/' + key).set({ Cidade: cidade, Status: true, Latitude: latitude, Longitude: longitude }).then(resp => {
      this.showToast('success', 'Cidade cadastrada com sucesso!', 'Status');
      return key;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Recupera as cidades cadastradas
  getCidades(uid) {
    return this.db.list('Clientes/' + environment.idCliente + '/Cidades').snapshotChanges();
  }

  //Recupera as cidades cadastradas
  getDadosEmpresa(uid) {
    return this.db.object('Clientes/' + environment.idCliente + '/DadosEmpresa').valueChanges();
  }

  //Recupera os dados do funcionário
  getFuncionario(idFuncionario) {
    console.log('Clientes/' + environment.idCliente + '/Funcionarios/' + idFuncionario)
    return this.db.object('Clientes/' + environment.idCliente + '/Funcionarios/' + idFuncionario).valueChanges();
  }

  //Recupera o contador de pedidos
  getContIdPedidos() {
    return this.db.object('Clientes/' + environment.idCliente + '/ContPedidos/').valueChanges();
  }

  //Recupera os produtos do pedido
  getProdutosPedido(idPedido) {
    return this.db.object('Clientes/' + environment.idCliente + '/Pedidos/' + idPedido).snapshotChanges();
  }

  //Recupera as promoções cadastradas
  getGruposPromocoes() {
    return this.db.list('Clientes/' + environment.idCliente + '/GruposPromocionais/').snapshotChanges();
  }

  //Cadastra um novo grupo promocional
  setGrupoPromocao(map) {
    const key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/GruposPromocionais/' + key).set(map).then(resp => {
      this.showToast('success', 'Grupo promocional cadastrado com sucesso!', 'Status');
      return key;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Atualiza o status de um grupo promocional
  updateStatusGrupoPromocional(key, b) {
    return this.db.object('Clientes/' + environment.idCliente + '/GruposPromocionais/' + key).update({ Status: b }).then(resp => {
      this.showToast('success', 'Status atualizado com sucesso!', 'Status');
      return true;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Recupera os grupos promocionais por nome
  getBuscaInicioGruposPromocionais(nome) {
    return this.db.list('Clientes/' + environment.idCliente + '/GruposPromocionais/', ref => ref.orderByChild('NomeBusca').startAt(nome.toUpperCase()).endAt(nome.toLowerCase() + '\uf8ff').limitToLast(50)).snapshotChanges();
  }

  //Cadastra o fechamento de uma comissao
  setComissao(uid, map) {
    const key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/Comissoes/' + '/' + key).set(map).then(resp => {
      this.showToast('success', 'Comissão registrada com sucesso!', 'Status');
      return true;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Recupera a comissão daquele mês específico
  getComissao(periodoString) {
    return this.db.list('Clientes/' + environment.idCliente + '/Comissoes/', ref => ref.orderByChild('Periodo').equalTo(periodoString)).snapshotChanges();
  }

  //Recupera os acessos com base no timestamp
  getAcessosTimestamp(timestampInicial, timestampFinal) {
    return this.db.list('Clientes/' + environment.idCliente + '/Usuarios', ref => ref.orderByChild('Timestamp').startAt(timestampInicial).endAt(timestampFinal)).snapshotChanges();
  }

  //Recupera os pedidos em que o estoque deve ser reestruturado. *Somente se o pedido não tiver sido alterado dentro de 24horas.
  getConferenciaEstoque() {
    return this.db.list('Clientes/' + environment.idCliente + '/ConferenciaEstoque', ref => ref.orderByChild('Visualizado').equalTo(false).limitToLast(1000)).snapshotChanges();
  }

  setTimestamp() {
    return this.db.object('Clientes/' + environment.idCliente + '/Timestamp/').set(firebase.default.database.ServerValue.TIMESTAMP).then(resp => {
      return true;
    }).catch(err => {
      console.log(err);
      return false;
    });
  }

  //Recupera o timestamp do servidor.
  getTimestamp() {
    return this.db.object('Clientes/' + environment.idCliente + '/Timestamp').snapshotChanges();
  }

  //Cadastro um novo funcionário
  validarEstoque(idPedidos) {
    return this.fns.httpsCallable('estornarProdutosEstoqueCompraCancelada')({ IDPedidos: idPedidos }).toPromise()
      .then(resp => {
        return resp;
      })
      .catch(err => {
        console.log(err);
        return {
          Status: false,
          Mensagem: "Error  DESCONHECIDO estornar produtos: " + err.code
        }
      });
  }

  //Recupera o estoque abaixo de 100 unidades para verificar o alerta de estoque
  getEstoqueAlertaQuantidadeMinima() {
    return this.db.list('Clientes/' + environment.idCliente + '/Produtos', ref => ref.orderByChild('QuantidadeEstoque').endAt(100).limitToLast(1000)).snapshotChanges();
  }

  //Chama a função em nuvem para estornar o estoque do pedido cancelado
  estornarProdutosPedidoCancelado(idPedido) {
    return this.fns.httpsCallable('estornarProdutosEstoqueCompraCanceladaADMINV3')({ IDPedido: idPedido }).toPromise()
      .then(resp => {
        return resp;
      })
      .catch(err => {
        console.log(err);
        return {
          Status: false,
          Mensagem: "Error  DESCONHECIDO estornar produtos: " + err.code
        }
      });
  }

  //Cadastra as rotas
  setRotas(map, idCidade) {
    console.log(map)
    return this.db.object('Clientes/' + environment.idCliente + '/Rotas/' + idCidade).set(map).then(resp => {
      this.showToast('success', 'Rotas atualizadas com sucesso!', 'Status');
      return true;
    }).catch(err => {
      console.log(err);
      this.showToast('error', 'Erro ao executar ação. Atualize a página e confirme se houve alteração!', 'Error');
      return false;
    });
  }

  //Retorna as áreas de rotas da cidade informada
  getRotas(idCidade) {
    return this.db.object('Clientes/' + environment.idCliente + '/Rotas/' + idCidade).valueChanges();
  }

  //Retorna todas as rotas
  getTodasRotas() {
    return this.db.list('Clientes/' + environment.idCliente + '/Rotas').snapshotChanges();
  }


  //Recupera os clientes com false na latitude
  getClientesFalseLatitude() {
    return this.db.list('Clientes/' + environment.idCliente + '/Usuarios', ref => ref.orderByChild('Latitude').equalTo(false).limitToLast(1000)).snapshotChanges();
  }

  //Recupera os clientes com false na latitude
  getSolicitacoesExclusaoDados() {
    return this.db.list('Clientes/' + environment.idCliente + '/SolicitacoesExclusaoDados', ref => ref.orderByChild('Status').equalTo(false).limitToLast(1000)).snapshotChanges();
  }

  getAllSolicitacoesExclusaoDados() {
    return this.db.list('Clientes/' + environment.idCliente + '/SolicitacoesExclusaoDados', ref => ref.limitToLast(10000)).snapshotChanges();
  }

  //Seta confirmação de visualização de solicitação de exclusão de dados
  setConfirmarVisualizacaoExclusaoDeDado(idSolicitacao: string) {
    const map = {
      Status: true,
      TimestampVisualizacao: firebase.default.database.ServerValue.TIMESTAMP
    }
    return this.db.object('Clientes/' + environment.idCliente + '/SolicitacoesExclusaoDados/' + idSolicitacao).update(map).then(resp => {
      return true;
    }).catch(err => {
      console.log(err);
      return false;
    });
  }

  //Solicita validação da senha master
  validarSenhaMaster(senhaMaster) {
    return this.fns.httpsCallable('validarSenhaMaster')({ SenhaMaster: senhaMaster }).toPromise()
      .then(resp => {
        return resp;
      })
      .catch(err => {
        console.log(err);
        return {
          Status: false,
          Mensagem: "Error  DESCONHECIDO ao solicitar validação senha master: " + err.code
        }
      });
  }

  setLogEstoque(descricao, mapDados, uid) {
    let auxDate = new Date();
    let map = {
      IP: localStorage.getItem('ip'),
      Timestamp: auxDate.getTime(),
      TimestampServidor: firebase.default.database.ServerValue.TIMESTAMP,
      Descricao: descricao,
      IDCliente: uid,
      IDCliente_Timestamp: uid + '_' + auxDate.getTime(),
      IP_Timestamp: localStorage.getItem('ip') + '_' + auxDate.getTime(),
      Map: mapDados ? JSON.stringify(mapDados) : false
    }

    let key = this.db.createPushId();
    this.db.object('Clientes/' + environment.idCliente + '/LogEstoque/' + key).set(map);
  }

  setLogAlteracaoPedido(descricao, mapDados, uid) {
    let auxDate = new Date();
    let map = {
      IP: localStorage.getItem('ip'),
      Timestamp: auxDate.getTime(),
      TimestampServidor: firebase.default.database.ServerValue.TIMESTAMP,
      Descricao: descricao,
      IDCliente: uid,
      IDCliente_Timestamp: uid + '_' + auxDate.getTime(),
      IP_Timestamp: localStorage.getItem('ip') + '_' + auxDate.getTime(),
      Map: mapDados ? JSON.stringify(mapDados) : false
    }

    let key = this.db.createPushId();
    return this.db.object('Clientes/' + environment.idCliente + '/LogAlteracaoPedido/' + key).set(map);
  }

  excluirCliente(idCliente) {
    return this.fns.httpsCallable('excluirCliente')({ IDCliente: idCliente }).toPromise()
      .then(resp => {
        return resp;
      })
      .catch(err => {
        console.log(err);
        return {
          Status: false,
          Mensagem: "Error  DESCONHECIDO ao excluir o cliente: " + err.code
        }
      });
  }

  //Recupera os acessos com base no timestamp
  getConferenciaEstoqueTimestamp(timestampInicial, timestampFinal) {
    return this.db.list('Clientes/' + environment.idCliente + '/ConferenciaEstoque', ref => ref.orderByChild('Timestamp').startAt(timestampInicial).endAt(timestampFinal)).snapshotChanges();
  }

  //Recupera os acessos com base no timestamp
  getLogEstoqueTimestamp(timestampInicial, timestampFinal) {
    return this.db.list('Clientes/' + environment.idCliente + '/LogEstoque', ref => ref.orderByChild('Timestamp').startAt(timestampInicial).endAt(timestampFinal)).snapshotChanges();
  }

  //Atualiza a taxa da promoção nos usuários
  updateTaxaPromocao(idUsuario, idGrupo, porcentagemDesconto) {
    return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idUsuario + '/GruposPromocionais/' + idGrupo + '/PorcentagemDesconto').set(porcentagemDesconto);
  }

  //Atualiza o grupo promocional em cada cliente
  updateGrupoPromocionalUsuario(idUsuario, map) {
    if (map) {
      return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idUsuario + '/GruposPromocionais/').remove().finally(() => {
        //return setTimeout(() => )
        return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idUsuario + '/GruposPromocionais/').set(map);
      });
    } else
      return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idUsuario + '/GruposPromocionais/').remove();
  }


  //#region Boletos sicoob
  getBoletosTimestamp(timestampInicial, timestampFinal, tipoBusca) {
    if (tipoBusca === 'Data de emissão') {
      return this.db.list('Clientes/' + environment.idCliente + '/Boletos', ref => ref.orderByChild('TimestampEmissao').startAt(timestampInicial).endAt(timestampFinal)).snapshotChanges();
    } else {
      return this.db.list('Clientes/' + environment.idCliente + '/Boletos', ref => ref.orderByChild('TimestampVencimento').startAt(timestampInicial).endAt(timestampFinal)).snapshotChanges();
    }
  }

  criarBoleto(map: any, key: string) {
    return this.db.object('Clientes/' + environment.idCliente + '/Boletos/' + key).set(map);
  }

  getBoleto(idBoleto: string) {
    return this.db.object('Clientes/' + environment.idCliente + '/Boletos/' + idBoleto).valueChanges();
  }

  async updateBoletoPedido(idPedido: number, map: any) {
    return await this.db.object('Clientes/' + environment.idCliente + '/Pedidos/' + idPedido).update(map).then(resp => {
      return true;
    }).catch(err => {
      return false;
    });
  }

  getAllBoletosPendentes() {
    return this.db.list('Clientes/' + environment.idCliente + '/Boletos', ref => ref.orderByChild('SituacaoBoleto').equalTo('Em Aberto').limitToLast(1000)).snapshotChanges();
  }

  getBoletosPorPedido(pedido: number) {
    return this.db.list('Clientes/' + environment.idCliente + '/Boletos', ref => ref.orderByChild('Pedido').equalTo(pedido)).snapshotChanges();
  }

  async updateStatusBoleto(idBoleto, map: any) {
    return await this.db.object('Clientes/' + environment.idCliente + '/Boletos/' + idBoleto).update(map).then(resp => {
      return true;
    }).catch(err => {
      return false;
    });
  }
  //#endregion

  //#region CreditoVoucher
  getCreditoVoucherCliente(idCliente: string) {
    return this.db.object('Clientes/' + environment.idCliente + '/CreditoVoucherClientes/' + idCliente).valueChanges();
  }

  pushHistoricoCreditoVoucher(idCliente: string, map: CreditoVoucherHistorico) {
    const key = this.db.createPushId();
    this.db.object('Clientes/' + environment.idCliente + '/CreditoVoucherClientes/' + idCliente).update({ TimestampUltimoCreditoVoucher: firebase.default.database.ServerValue.TIMESTAMP });
    return this.db.object('Clientes/' + environment.idCliente + '/CreditoVoucherClientes/' + idCliente + '/Historico/' + key).update(map);
  }

  getHistoricoCreditoVoucher(idCliente: string) {
    return this.db.list('Clientes/' + environment.idCliente + '/CreditoVoucherClientes/' + idCliente + '/Historico').snapshotChanges();
  }

  setCompraPagamentoPendenteTrue(key: string) {
    return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + key).update({ CompraPagamentoPendente: false });
  }
  //#endregion

  //Recupera o Estoque
  getEstoqueProdutos() {
    return this.db.list(`Clientes/${environment.idCliente}/EstoqueProdutos`).snapshotChanges();
  }

  getEstoqueProduto(idProduto: string) {
    return this.db.object(`Clientes/${environment.idCliente}/EstoqueProdutos/${idProduto}/QuantidadeEstoque`).valueChanges();
  }

  async getEstoquesProdutos(): Promise<ProdutoEstoqueElement[]> {
    return await new Promise(resolve => {
      this.getEstoqueProdutos().pipe(take(1)).subscribe(snap => {
        let estoques: ProdutoEstoqueElement[] = [];

        snap.forEach((item) => {
          estoques.push({
            ID: item.key,
            QuantidadeEstoque: (item.payload.val() as ProdutoEstoqueConsulta).QuantidadeEstoque,
            Nome: ''
          });
        });

        resolve(estoques);
      });
    });
  }

  getEstoqueProdutoTimestamp(idProduto, timestampInicial, timestampFinal) {
    return this.db.list(`Clientes/${environment.idCliente}/EstoqueProdutos/${idProduto}/Historico`, ref => ref.orderByChild('Timestamp').startAt(timestampInicial).endAt(timestampFinal)).snapshotChanges();
  }

  async setLogEstoqueProdutos(map: LogEstoqueProdutos, idProduto: string) {
    const key = this.db.createPushId();
    return await this.db.object(`Clientes/${environment.idCliente}/EstoqueProdutos/${idProduto}/Historico/${key}`).set(map);
  }

  //#region Sistema
  getSistema() {
    return this.db.object('Clientes/' + environment.idCliente + '/Sistema/Loja').snapshotChanges();
  }

  async updateSistema(map: Loja) {
    try {
      await this.db.object('Clientes/' + environment.idCliente + '/Sistema/Loja').update(map);
      return {
        Status: true,
        Mensagem: "Sistema atualizado com sucesso!"
      };
    } catch (err) {
      return {
        Status: false,
        Mensagem: "Error  DESCONHECIDO ao atualizar o sistema: " + err.toString()
      };
    }
  }
  //#endregion

  //Atualizar crédito total do cliente
  async updateCreditoTotalCliente(credito: number, idCliente: string) {
    console.log('updateCreditoTotalCliente', credito)
    console.log('Clientes/' + environment.idCliente + '/Usuarios/' + idCliente)
    return this.db.object('Clientes/' + environment.idCliente + '/Usuarios/' + idCliente).update({ Credito: credito }).then(resp => {
      return true;
    }).catch(err => {
      return false;
    });
  }

  async updatePedidoDinheiroPago(idPedido: number) {
    return await this.db.object('Clientes/' + environment.idCliente + '/Pedidos/' + idPedido).update({
      FormaPagamento: 'Dinheiro',
      StatusPagamento: 'Pago',
      SituacaoBoleto: 'Cancelado'
    }).then(() => {
      console.log('updatePedidoDinheiroPago', idPedido);
      return;
    });
  }


  //Alerta
  showToast(tipo, titulo, msg) {
    switch (tipo) {
      case 'error':
        this.toastr.error(msg, titulo, { progressBar: true, positionClass: 'toast-top-center', });
        break;
      case 'info':
        this.toastr.info(msg, titulo, { progressBar: true, positionClass: 'toast-top-center', });
        break;
      case 'success':
        this.toastr.success(msg, titulo, { progressBar: true, positionClass: 'toast-top-center', });
        break;
      case 'warning':
        this.toastr.warning(msg, titulo, { progressBar: true, positionClass: 'toast-top-center', });
        break;
    }
  }

  tratarUnidade(tratar) {
    let unidade = tratar.toLowerCase()
    if (unidade.includes('caixa')) {
      return 'Cx';
    } else
      if (unidade.includes('fardo')) {
        return 'Fd';
      } else
        if (unidade.includes('litro')) {
          return 'L';
        } else
          if (unidade.includes('peça')) {
            return 'Pc';
          } else
            if (unidade.includes('unidade')) {
              return 'Uni';
            } else
              if (unidade.includes('kilograma')) {
                return 'Kg';
              } else
                return unidade.substring(0, unidade.length >= 3 ? 3 : unidade.length);
  }

  //Trata Numero de Dada, Hora para exibicao dos dados
  tratarString(data) {
    if (data.toString().length < 2) {
      return '0' + data;
    } else {
      return '' + data;
    }
  }

  tratarDataHora(timestamp: any) {
    let auxDate = new Date();
    auxDate.setTime(timestamp);
    let sData = this.tratarString(auxDate.getDate()) + '/' + this.tratarString(auxDate.getMonth() + 1) + '/' + auxDate.getFullYear() + ' às ' + this.tratarString(auxDate.getHours()) + ':' + this.tratarString(auxDate.getMinutes());
    return sData
  }

  tratarData(timestamp: any) {
    let auxDate = new Date();
    auxDate.setTime(timestamp);
    let sData = this.tratarString(auxDate.getDate()) + '/' + this.tratarString(auxDate.getMonth() + 1) + '/' + auxDate.getFullYear();
    return sData
  }

  tratarHora(timestamp: any) {
    let auxDate = new Date();
    auxDate.setTime(timestamp);
    let sHora = this.tratarString(auxDate.getHours()) + ':' + this.tratarString(auxDate.getMinutes());
    return sHora
  }

  tratarMesData(timestamp: any) {
    let auxDate = new Date();
    auxDate.setTime(timestamp);
    // let sData = this.tratarString(auxDate.getMonth() + 1) + '/' + auxDate.getFullYear();
    let sData = this.tratarString(auxDate.getMonth()) + '/' + auxDate.getFullYear(); //Para evitar erro, foi removido o +1, estava voltando ao mês atual
    return sData
  }

  tratarMesDataComSomaMes(timestamp: any) {
    let auxDate = new Date();
    auxDate.setTime(timestamp);
    // let sData = this.tratarString(auxDate.getMonth() + 1) + '/' + auxDate.getFullYear();
    let sData = this.tratarString(auxDate.getMonth() + 1) + '/' + auxDate.getFullYear();
    return sData;
  }
}
